import { render } from "./TabelaRequisicoes.vue?vue&type=template&id=0583720a&scoped=true"
import script from "./TabelaRequisicoes.vue?vue&type=script&lang=js"
export * from "./TabelaRequisicoes.vue?vue&type=script&lang=js"

import "./TabelaRequisicoes.vue?vue&type=style&index=0&id=0583720a&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0583720a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QCheckbox,QCardSection,QImg,QTr,QTh,QTd,QTooltip,QIcon,QPagination});
